// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.selectborder[data-v-055331e6] {\n  border-left: 4px solid var(--v-secondary-darken2) !important;\n}\n.messageborder[data-v-055331e6] {\n  border: 1px solid rgb(224, 224, 224) !important;\n}\n.rounded-custom[data-v-055331e6] {\n  border-radius: 4px;\n}\n.successborder[data-v-055331e6] {\n  border-right: 4px solid var(--v-success-darken1) !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
